import {StackType} from "./StackTypes";

const StackVertical = (props: StackType) => {
    return (
        <div className={`flex-column ${props.wrap ? 'flex-wrap' : ''} ${props.fillHeight ? 'fill-height' : ''} ${props.gap ? props.gap : ''} ${props.align ? props.align : ''} ${props.justify ? props.justify : ''} ${props.extraClass ? props.extraClass: ''} ${props.hide ? 'hide' : ''}`}>
            {props.children}
        </div>
    )
}

export default StackVertical;